import { render, staticRenderFns } from "./TimeToSale.vue?vue&type=template&id=6fc00777&"
import script from "./TimeToSale.vue?vue&type=script&lang=js&"
export * from "./TimeToSale.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports